if (!customElements.get('card-quick-add')) {
  customElements.define(
    'card-quick-add',
    class CardQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        const data = this.querySelector('[data-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.variantInput = this.querySelector('.product-variant-id');
        this.priceEl = this.querySelector('[data-price-current]');
        this.compareEl = this.querySelector('[data-price-compare]');
        this.imageEl = this.querySelector('[data-quick-add-image]');
        this.button = this.querySelector('[name="add"]');
        this.buttonText = this.querySelector('[data-add-text]');
        this.fallbackImage = this.imageEl ? this.imageEl.getAttribute('src') : null;

        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) this.syncVariant();
        });
      }

      selectedOptions() {
        return Array.from(this.querySelectorAll('.card-quick-add__option')).map((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : '';
        });
      }

      syncVariant() {
        const selected = this.selectedOptions();
        const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant || !this.button) return;

        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;
        this.button.disabled = !variant.available;
        this.button.removeAttribute('aria-disabled');

        if (this.buttonText) {
          this.buttonText.textContent = variant.available
            ? window.variantStrings?.addToCart || 'Add to cart'
            : window.variantStrings?.soldOut || 'Sold out';
          this.buttonText.classList.remove('hidden');
        }

        const soldOutMessage = this.button.querySelector('.sold-out-message');
        if (soldOutMessage) soldOutMessage.classList.add('hidden');

        if (this.priceEl) this.priceEl.textContent = variant.price;

        if (this.compareEl) {
          if (variant.compare_at_price) {
            this.compareEl.hidden = false;
            this.compareEl.textContent = variant.compare_at_price;
          } else {
            this.compareEl.hidden = true;
            this.compareEl.textContent = '';
          }
        }

        if (this.imageEl) {
          this.imageEl.src = variant.image || this.fallbackImage;
        }
      }
    }
  );
}
